import { type StatementItem } from '@webapp/modules/accounts-payable/entities/StatementItem'
import { useCreateStatementItemFormPresenter } from './useCreateStatementItemFormPresenter'
import { StatementItemForm } from '../../views/StatementItemForm'

export interface ICreateStatementItemFormPresenterProps {
  /** Hidden `creditcard` payload field */
  accountId: number
  /** FS unshifts with "JUST CREATED" + tracks the id (BHV-041) */
  onCreated: (item: StatementItem) => void
  onCancel: () => void
}

// Form content only — the ModalDialog wrapper is FS-owned.
export const CreateStatementItemFormPresenter = ({
  accountId,
  onCreated,
  onCancel,
}: ICreateStatementItemFormPresenterProps) => {
  const {
    states: { isCreating },
    methods: { onSubmit },
  } = useCreateStatementItemFormPresenter({ accountId, onCreated })

  return (
    <StatementItemForm
      isSaving={isCreating}
      onSubmit={onSubmit}
      onCancel={onCancel}
    />
  )
}

CreateStatementItemFormPresenter.displayName =
  'CreateStatementItemFormPresenter'
